var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17V26H24V17",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 6L5.00001 11C4.9985 11.6744 5.22485 12.3295 5.64235 12.8591C6.05985 13.3886 6.64402 13.7617 7.3001 13.9176C7.95619 14.0735 8.64572 14.0033 9.25686 13.7182C9.86801 13.4331 10.3649 12.9499 10.667 12.347C10.9135 12.8435 11.2937 13.2613 11.7648 13.5534C12.2359 13.8455 12.7792 14.0003 13.3335 14.0003C13.8878 14.0003 14.4311 13.8455 14.9022 13.5534C15.3733 13.2613 15.7535 12.8435 16 12.347C16.2465 12.8435 16.6267 13.2613 17.0978 13.5534C17.5689 13.8455 18.1122 14.0003 18.6665 14.0003C19.2208 14.0003 19.7641 13.8455 20.2352 13.5534C20.7063 13.2613 21.0865 12.8435 21.333 12.347C21.6351 12.9499 22.132 13.4331 22.7432 13.7182C23.3543 14.0033 24.0438 14.0735 24.6999 13.9176C25.356 13.7617 25.9402 13.3886 26.3577 12.8591C26.7752 12.3295 27.0015 11.6744 27 11L24 6H8.00001Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26V20H18V26",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress3);
export default __webpack_public_path__ + "static/media/Address_3.4a25089ace82df7b1c9bb663c888927f.svg";
export { ForwardRef as ReactComponent };